import styled from '@emotion/styled';

import useIntersectionAnimate from '../../../hooks/useIntersectionObserver';

const TrackingSection = () => {
  useIntersectionAnimate('.intersection-animate', 'animate', {
    threshold: 0.5,
  });

  return (
    <Container className='intersection-animate'>
      <TextContent>
        <MainHeading>
          Achieve full visibility into the entire lifecycle of your parcels from origin to your doorstep
        </MainHeading>
        <Description>
          Easily track your items by entering the provided tracking code to access real-time updates, receive alerts on any issues, and get notified upon successful delivery.
        </Description>

      </TextContent>
      <ImageWrapper>
        <img src='/static/img/cml/et-aero.png' alt='Ethiopian Airlines plane on runway' />
      </ImageWrapper>
    </Container >
  );
};

export default TrackingSection;


const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 80px;
  padding: 100px 0;

  @media (max-width: 884px) {
    display: flex;
    flex-direction: column;
    padding: 55px 0;
    gap: 40px;
  }

  @media (max-width: 480px) {
    gap: 24px;
  }

    &.animate {
    /* background-color: red; */
    animation-delay: 0.2s;
    animation-duration: 0.4s;
    animation-fill-mode: backwards;
    animation-name: move;

    @keyframes move {
      from {
        transform: translateY(40%);
        /* background-color: green; */
      }
      to {
        transform: 0;
        /* background-color: orange; */
      }
    }
  }
`;

const TextContent = styled.div`
  width: 60%;
  flex: 1;
  // padding: 60px 50px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: 1024px) {
    padding: 40px 30px;
    align-items: center;
  }

  @media (max-width: 768px) {
  width: 100%;
    padding: 0;
  }
`;

const MainHeading = styled.h2`
  font-size: 50px;
  font-weight: 700;
  line-height: 1.2;
  color: #000000;
  margin: 0;

  @media (max-width: 1280px) {
    font-size: 46px;
  }

  @media (max-width: 1024px) {
    font-size: 36px;
  }

  @media (max-width: 768px) {
    font-size: 28px;
  }
`;

const Description = styled.p`
  font-size: 20px;
  font-weigth: 500px;
  line-height: 1.6;
  color: #000000CC;
  margin: 0;

  @media (max-width: 1024px) {
    font-size: 18px;
  }
`;



const ImageWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;

  img {
    width: 100%;
    height: auto;
    max-width: 551px;
    object-fit: cover;
    border-radius: 12px;
  }
`;